import { clx } from "../../../../helpers/components"
import { Twofactor } from "../AuthForm/TwofactorPage"
import style from "./style.module.scss"
export const A2fCherker = () => { 
    return (<div style={{flex:1}}>
            <div className={clx(style.pageContainer, "container")}>
                <Twofactor/>
            </div>    
        </div>)
}